const wowApp = require('angular').module('wowApp.shop');

wowApp.constant('ReviewApiRoutes', {
   proxyName: 'bazaar',
   add: `/products/{productId}/reviews`,
   getByProductId: `/products/{productId}?sort={sort}`,
   getByShopperId: `/authors/{shopperId}?sort={sort}`,
   vote: `/reviews/{reviewId}`,
   report: `/reviews/{reviewId}`
});

wowApp.constant('SecureApiRoutes', {
   token: `/token`
});

wowApp.filter('chunk', [require('./list-review/chunk-filter')]);
wowApp.directive('ageValidator', [require('./age-validator.js')]);
wowApp.service('UrlService', [require('./url-service')]);
wowApp.service('SecureApiCall', ['ProxyService', 'CurrentUserService', 'SecureApiRoutes', 'UrlService', require('./secure-api-call')]);


wowApp.service('ReviewService', ['ProxyService', 'BazaarvoiceService', 'SecureApiCall', 'ReviewApiRoutes', 'UrlService', require('./review-service')]);
// For testing and developing I recommend you use the mocked API
// wowApp.service('ReviewService', [require('./mocked-review-service')]);

wowApp.directive('wowSliderNavigation', [require('./post-review/slide-navigation-directive')]);
wowApp.service('CreateFormWizard', ['$parse', require('./post-review/create-form-wizard')]);
wowApp.directive('wowPostReview', ['CurrentUserService', 'ReviewService', 'SettingsService', 'CreateFormWizard', '$state', '$stateParams', '$location', '$window', '$timeout', 'jQuery', 'ShopLocatorService', '$uibModal', require('./post-review/post-review-directive')]);
wowApp.directive('wowReviewCard', ['ReviewService', 'BazaarvoiceService', 'SettingsService', 'CurrentUserService', '$state', 'hyphenateFilter', require('./cards/review-card-directive')]);
wowApp.directive('bwsRibbon', [require('./cards/ribbon-directive')]);


wowApp.directive('wowReviewListing', [require('./list-review/review-listing-directive')]);
wowApp.directive('wowPreviewReviewListing', [require('./list-review/review-preview-listing-directive')]);

wowApp.directive('wowProductReviewHeading', ['GlobalHeaderPanelService', 'BreakpointsService', '$state', '$timeout', 'BwsNotificationService', 'AtmService', require('./headings/product-review-heading-directive')]);
wowApp.directive('wowStandardHeading', [require('./headings/standard-heading-directive')]);

wowApp.directive('wowReviewOverview', [require('./review-overview-directive')]);
wowApp.controller('ReviewController', ['ReviewFactory', 'SettingsService', 'CurrentUserService', '$state', '$stateParams', require('./review-controller')]);

wowApp.service('ReviewsByProduct', ['ReviewService', 'currentProduct', '$state', '$stateParams', require('./factory/reviews-by-product')]);
wowApp.service('ReviewsByShopper', ['ReviewService', '$state', '$stateParams', require('./factory/reviews-by-shopper')]);
wowApp.service('ReviewsByStore', ['ReviewService', '$state', '$stateParams', require('./factory/reviews-by-store')]);
wowApp.service('ReviewFactory', ['ReviewsByProduct', 'ReviewsByShopper', 'ReviewsByStore', require('./factory/review-factory')]);


wowApp.run(($templateCache) => {
   $templateCache.put('card-view', require('./cards/review-card-view-template.html'));
   $templateCache.put('card-report', require('./cards/review-card-report-template.html'));
});



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/index.js
 **/